export enum ClosedEmitterTypes {
  Click = 'click',
  Keydown = 'keydown',
  Tab = 'tab',
}
